export default __webpack_public_path__ + "static/media/2_en.f201efde.png";